import ExhibitionView from './ExhibitionView';

export default ExhibitionView;
